<template>
	<div class="nav-sub js-nav-level">
		<template v-for="(item, itemIndex) in navItems">
			<component
				:is="getItemElement(item)"
				:key="`item-${item.id}`"
				:type="!item.link && hasChildren(item) ? 'button' : null"
				:href="item.link"
				:target="item.link ? (mixinIsExternalLink(item.link) ? '_blank' : '_self') : null"
				:rel="item.link && mixinIsExternalLink(item.link) ? 'noopener' : null"
				class="nav-sub__item"
				:class="{
					'is-active': item.id === openItemId && hasChildren(item),
					'-has-divider': itemIndex < navItems.length - 1,
				}"
				:aria-expanded="hasChildren(item) ? (item.id === openItemId ? 'true' : 'false') : null"
				:aria-controls="hasChildren(item) ? getChildId(item) : null"
				:aria-current="item.isActive ? 'page' : null"
				@focus="openChildren(item.id)"
				@mouseover.stop="openChildren(item.id)"
				@click="item.link ? null : openChildren(item.id)"
			>
				<div class="nav-sub__item-inner-w">
					<span class="nav-sub__item-text">{{ item.title }}</span>
					<V2Icon
						v-if="mixinIsExternalLink(item.link)"
						icon-name="launch"
						size="xxs"
					/>
					<V2Icon
						v-if="hasChildren(item)"
						icon-name="right-arrow"
						size="sm"
					/>
				</div>
			</component>
			<NavSub
				v-if="hasChildren(item)"
				v-show="item.id === openItemId"
				:id="getChildId(item)"
				:key="`child-${item.id}`"
				class="-child"
				:aria-hidden="item.id !== openItemId"
				:inert="item.id === openItemId ? null : ''"
				:nav-items="item.children"
			/>
		</template>
	</div>
</template>

<script>
import V2Icon from '@shared/components/Icon';

export default {
	name:       'NavSub',
	components: { V2Icon },
	props:      {
		navItems: {
			type:    Array,
			default: () => [],
		},
	},
	data() {
		return {
			openItemId: null,
		};
	},
	methods: {
		hasChildren(item) {
			return Boolean(item.children && item.children.length > 0);
		},
		getItemElement(item) {
			if (item.link) {
				return 'a';
			}

			return this.hasChildren(item) ? 'button' : 'span';
		},
		getChildId(item) {
			return `desktop-nav-child-${item.id}`;
		},
		openChildren(itemId) {
			this.openItemId = itemId;
		},
	},
};
</script>

<style lang="scss" scoped>
@use 'sass:math';
@import '@sass/variables';

$column-gap: $sp6;
$column-width: calc((100% / 3) - #{math.div(($column-gap * 2), 3)});

.nav-sub {
	display: flex;
	flex-direction: column;
	width: $column-width;
	position: relative;
	gap: 0 $sp3;

	.nav-sub.-child {
		position: absolute;
		top: 0;
		left: calc(100% + $column-gap);
		width: 100%;
		height: 100%;
	}
}

.nav-sub__item {
	display: flex;
	width: 100%;
	padding: 0;
	border: 0;
	background-color: transparent;
	color: var(--color-grey-600);
	text-align: left;
	cursor: pointer;
	user-select: none;

	.nav-sub__item {
		width: 100%;
	}

	&:hover,
	&.is-active {
		color: var(--color-white);

		body.-t-light & { // stylelint-disable-line selector-max-type, selector-no-qualifying-type
			color: var(--color-black);
		}
	}
}

span.nav-sub__item { // stylelint-disable-line selector-max-type, selector-no-qualifying-type
	cursor: auto !important; // stylelint-disable-line declaration-no-important
}

.nav-sub__item-inner-w {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: $sp4 0;
	white-space: nowrap;

	.nav-sub__item.-has-divider & {
		border-bottom: 1px solid var(--color-grey-900);
	}
}

.nav-sub__item-text {
	@include ellipsis;
}
</style>
